var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-travel-sausage"},[_c('travel-sausage-badge',{attrs:{"color":_vm.color,"traffic-type":_vm.trafficType}}),_c('span',[_vm._v(" "+_vm._s(_vm.text)+_vm._s(_vm.trafficType === "walk" ? "." : "")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }